import React, {createElement, useState, useContext} from 'react';
import {Activities, UI, DateContext} from 'components';
import {preventDefault, returnNull, useUpdateEffect, useEvent, useRafLoop, useDragStart, useNamedSelector, useGrabbed} from 'helpers';

export function Card(props) {
  return createElement(props.isActivity ? ActivityCard : GoalCard, props);
}

function ActivityCard({style, isAllDay, ...activity}) {
  const [offset, setOffset] = useState();
  const grabbed = useGrabbed();
  const contextDate = useContext(DateContext);
  const isGrabbed = grabbed?.id === activity.id && grabbed?.type.match(/activity/) && grabbed?.contextDate.isSame(contextDate);
  const isResizing = grabbed?.id === activity.id && grabbed?.type.match(/-handle/) && grabbed?.contextDate.isSame(contextDate);

  const [stop, start] = useRafLoop(() => {
    if (!grabbed) {
      setOffset();
    } else if (grabbed.start && grabbed.type === 'top-handle') {
      setOffset({
        top: grabbed.start.top,
        zIndex: 5
      });
    } else if (grabbed.end) {
      setOffset({
        bottom: grabbed.end.bottom,
        zIndex: 5
      });
    }
  }, false);

  useUpdateEffect(() => {
    requestAnimationFrame(isResizing ? start : stop);
  }, [isResizing]);

  useEvent('dragover', isResizing && preventDefault);

  return (
    <Activities.Card
      className={isGrabbed && 'isPlaceholder'}
      ActionMenu={returnNull}
      Body={Activities.BodyCalendar}
      Checkbox={Activities.Checkbox}
      contextDate={contextDate}
      detailed={false}
      Footer={false}
      isAllDay={isAllDay}
      isSmall={!isAllDay && activity.duration > 0 && activity.duration < 20}
      onCalendar
      resize={!isAllDay}
      style={{...style, ...offset}}
      {...activity}
      {...useDragStart({type: 'calendar-activity', contextDate, ...activity})}
    />
  );
}

function GoalCard({ goal: { id } }) {
  const { name, parentGoal, ...rest } = useNamedSelector('goals.details', { id });
  const goal = parentGoal || rest;
  return (
    <UI.Card onCalendar navLink={`/goals/${goal.id}/`}>
      <UI.Card.Thumbnail src={goal.image} background={goal.category} />
      <UI.Card.Body>
        { name }
        { parentGoal &&
          <UI.Card.Note>
            { parentGoal.name }
          </UI.Card.Note>
        }
      </UI.Card.Body>
    </UI.Card>
  );
}
